import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
  initCommonAction, initCommonActionResult, initCommonClearAction,
  initCommonClearList,
  initCommonGetList,
  initCommonSetListResult,
} from "../highOrderReducers/commonReducer";
import {
  IBrokerAircraftSearchPayload,
  IMultiLegRequestPayload,
  INewRequestInitialState,
  IOneWayRequestPayload,
  IRoundTripRequestPayload,
  ISetBrokerAircraftSearchResultPayload
} from "./newRequestReducerTypes";
import {nameof} from "../../../utils/helpers/tsHelpers/nameof";

const newRequestInitialState: INewRequestInitialState = {
  oneWayRequest: {
    isLoading: false,
    isSuccess: false,
    errorMessage: '',
  },
  roundTripRequest: {
    isLoading: false,
    isSuccess: false,
    errorMessage: '',
  },
  multiLegRequest: {
    isLoading: false,
    isSuccess: false,
    errorMessage: '',
  },
  brokerAircraftSearch: {
    items: [],
    isLoading: false,
    totalCount: 0,
  }
}

const newRequestSlice = createSlice({
    name: 'newRequest',
    initialState: newRequestInitialState,
    reducers: {
      oneWayRequest(state, {payload}: PayloadAction<IOneWayRequestPayload>) {
        initCommonAction(state, nameof<INewRequestInitialState>("oneWayRequest"));
      },
      clearOneWayRequest(state) {
        initCommonClearAction(state, nameof<INewRequestInitialState>("oneWayRequest"))
      },
      oneWayRequestResult(state, {payload}: PayloadAction<{ errorMessage?: string }>) {
        initCommonActionResult(state, payload, nameof<INewRequestInitialState>("oneWayRequest"))
      },

      roundTripRequest(state, {payload}: PayloadAction<IRoundTripRequestPayload>) {
        initCommonAction(state, nameof<INewRequestInitialState>("roundTripRequest"));
      },
      clearRoundTripRequest(state) {
        initCommonClearAction(state, nameof<INewRequestInitialState>("roundTripRequest"))
      },
      roundTripRequestResult(state, {payload}: PayloadAction<{ errorMessage?: string }>) {
        initCommonActionResult(state, payload, nameof<INewRequestInitialState>("roundTripRequest"))
      },

      multiLegRequest(state, {payload}: PayloadAction<IMultiLegRequestPayload>) {
        initCommonAction(state, nameof<INewRequestInitialState>("multiLegRequest"));
      },
      clearMultiLegRequest(state) {
        initCommonClearAction(state, nameof<INewRequestInitialState>("multiLegRequest"))
      },
      multiLegRequestResult(state, {payload}: PayloadAction<{ errorMessage?: string }>) {
        initCommonActionResult(state, payload, nameof<INewRequestInitialState>("multiLegRequest"))
      },

      brokerAircraftSearch(state, {payload}: PayloadAction<IBrokerAircraftSearchPayload>) {
        state.brokerAircraftSearch.isLoading = true;
        if (payload.page === 0) {
          state.brokerAircraftSearch.items = [];
          state.brokerAircraftSearch.totalCount = 0;
        }
        state.lastSearchPayload = payload;
        // Сохраняем параметры поиска
        state.lastSearchParams = {
          airportFromId: payload.originAirportId,
          airportToId: payload.destinationAirportId,
          pax: payload.pax,
          departureTime: payload.departureTime,
          paxTo: payload.paxTo,
          multilegRoutes: payload.multilegRoutes,
        };
        if (payload.departureDate) {
          state.lastSearchParams.departureDate = new Date(payload.departureDate);
        }
      },
      clearBrokerAircraftSearch(state) {
        state.brokerAircraftSearch.items = [];
        state.brokerAircraftSearch.totalCount = 0;
        state.brokerAircraftSearch.isLoading = false;
        state.lastSearchPayload = undefined;
      },
      setBrokerAircraftSearchResult(state, {payload}: PayloadAction<ISetBrokerAircraftSearchResultPayload>) {
        state.brokerAircraftSearch.items = payload.aircraft;
        state.brokerAircraftSearch.totalCount = payload.totalCount;
        state.brokerAircraftSearch.isLoading = false;
        if (payload.aircraftEntities) {
          state.brokerAircraftEntities = payload.aircraftEntities;
        }
        if (payload.errorMessage) {
          state.brokerAircraftSearch.isLoading = false;
        }
        // Сохраняем данные аэропортов для отображения маршрута
        if (payload.originAirport) {
          if (!state.lastSearchParams) {
            state.lastSearchParams = {};
          }
          state.lastSearchParams.airportFrom = payload.originAirport;
        }
        if (payload.destinationAirport) {
          if (!state.lastSearchParams) {
            state.lastSearchParams = {};
          }
          state.lastSearchParams.airportTo = payload.destinationAirport;
        }
      },
    }
  }
);

export const {
  oneWayRequest,
  clearOneWayRequest,
  oneWayRequestResult,

  roundTripRequest,
  clearRoundTripRequest,
  roundTripRequestResult,

  multiLegRequest,
  clearMultiLegRequest,
  multiLegRequestResult,

  brokerAircraftSearch,
  clearBrokerAircraftSearch,
  setBrokerAircraftSearchResult,
} =
  newRequestSlice.actions;
export default newRequestSlice.reducer;
